<template>
  <div style="height:100%;width:100%">
    <div class="box">
      <!--      <div class="topTitleBox">-->
      <!--        <p style="float: left">-->
      <!--          {{ item.name }} <span>{{ item.streamingstatus === 'normal' ? '在线' : '离线' }}</span>-->
      <!--        </p>-->
      <!--      </div>-->
      <div class="content">
        <!--        <video-->
        <!--          class="video"-->
        <!--          src="http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8"-->
        <!--        ></video>-->
        <!--        <div class="actionBox"></div>-->

        <jessibuca-video v-if="item&&item.streamingstatus === 'normal'" id="jessibuca" ref="jessibuca" class="video"
                         :video-url="`${$videoUrl}/rtp/${item['deviceId']}_${item['deviceId']}.live.flv`"></jessibuca-video>
        <div v-if="item&&item.streamingstatus !== 'normal'">
          <span class="off-line">设备已离线</span>
        </div>

      </div>
      <div class="message">
        <p><span>{{ item&&item.name }}</span></p>
        <p>
          <span>{{ item&&item.region }}</span>
          <!--          <el-button @click="fullScreen" type="text" style="color: #0090FF;">-->
          <!--            <Icon type="md-expand"/>-->
          <!--            全屏-->
          <!--          </el-button>-->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JessibucaVideo from '@/views/Screen/components/Video/JessibucaVideo.vue'

export default {
  name: "MonitorWindows",
  components: { JessibucaVideo },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  // mounted() {
  //   this.$refs.jessibuca.play()
  // },
  // beforeDestroy() {
  //   this.$refs.jessibuca.destroy()
  // },
  methods: {
    playVideo() {
      this.$nextTick(() => {
        // const url = `ws://144.123.135.25:8091/rtp/${this.item['deviceId']}_${this.item['deviceId']}.live.flv`
        this.$refs.jessibuca.play()
      })
    },
    close() {
      // this.$emit('close')
      this.$refs.jessibuca.destroy()
    },
    fullScreen() {
      this.$refs.jessibuca.fullscreen()
    }
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  height: 100%;
  position: relative;

  .topTitleBox {
    //height: 4vh;
    width: 100%;
    //line-height: 4vh;
    color: #ffffff;

    .rightIcon {
      font-size: 1rem;
      float: right;
      line-height: 4vh;
      margin-right: .6rem;
    }

    p {
      margin-left: 1rem;
      font-size: .8rem;

      span {
        color: #0090FF;
        font-size: .5rem;
        line-height: 4vh;
      }
    }
  }

  .content {
    width: 100%;
    height: 100%;
    //height: 15vh;
    //background: #ffffff;
    position: relative;

    .video {
      position: absolute;
      width: 100%;
      height: 100%;
      //height: 15vh;
      top: 0;
      left: 0;
    }

    .actionBox {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 3vh;
      width: 100%;
      background-color: red;
    }
  }

  .message {
    width: 100%;
    //height: 2.5vh;
    background: transparent;
    position: absolute;
    bottom: 0px;

    p {
      margin-left: .5rem;
      color: #BCCBEF;
      font-size: .7rem;

      &:nth-child(1) {
        margin-top: .2rem;
      }

      span {
        &:nth-child(2) {
          color: #ffffff;
        }
      }
    }
  }
}
.off-line{
  text-align: center;
  width: 100%;
  display: block;
  font-size: 1rem;
  color: #ccc;
  margin-top: 20%;
}
</style>
